(() => {
    const replaceState = history.replaceState;
    history.replaceState = function() {
        replaceState.apply(this, arguments);
        window.dispatchEvent(new Event('replacestate'));
    };

    window.addEventListener('replacestate', changeActiveProductImage);

    function changeActiveProductImage() {
        const variantID = new URLSearchParams(window.location.search).get('variant');
        if (!variantID) return;

        const activeButton = document.querySelector(`button.thumbnail[data-variant*="${variantID}"]`);
        if (!activeButton) return;

        activeButton.click();
    }
})();

/**
 * Fix for dependent variant options (e.g. Color → Length).
 *
 * When the first option (Color/Metal) changes:
 *  1. Hide disclosure list items that are invalid for the new colour.
 *  2. If the currently-selected secondary option is now invalid, auto-select
 *     the first valid one and dispatch a change event so the full variant
 *     pipeline (image, price, URL) runs correctly.
 */
(function initDependentVariantFix() {
    function getVariantData(variantSelectsEl) {
        const json = variantSelectsEl.querySelector('[type="application/json"]');
        if (!json) return [];
        try { return JSON.parse(json.textContent); } catch { return []; }
    }

    function getValidSecondaryValues(variantData, primaryValue, primaryOptionKey, secondaryOptionKey) {
        const seen = new Set();
        return variantData
            .filter(v => v[primaryOptionKey] === primaryValue && v[secondaryOptionKey] != null)
            .map(v => v[secondaryOptionKey])
            .filter(val => seen.has(val) ? false : seen.add(val));
    }

    function syncDisclosureList(disclosureEl, validValues) {
        const items = disclosureEl.querySelectorAll('.disclosure__item');
        items.forEach(li => {
            const a = li.querySelector('a[data-value]');
            if (!a) return;
            const val = a.dataset.value;
            // The first active item (current value) has no data-value that differs –
            // it is the li.disclosure__item--active element. Hide it if invalid too.
            li.hidden = validValues.length > 0 && !validValues.includes(val);
        });
    }

    function autoSelectFirstValid(disclosureEl, validValues, currentValue) {
        if (validValues.includes(currentValue)) return false; // current is still valid

        const firstValid = validValues[0];
        if (!firstValid) return false;

        // Update the hidden <select> that the variant-selects element reads from.
        const select = disclosureEl.querySelector('select[data-uc-select-value]');
        if (!select) return false;

        select.value = firstValid;

        // Update the visible button text.
        const buttonText = disclosureEl.querySelector('[data-uc-select-text] span');
        if (buttonText) buttonText.textContent = firstValid;

        // Update the active disclosure item (the always-visible one at the top of the list).
        const activeItem = disclosureEl.querySelector('.disclosure__item--active a[data-value]');
        if (activeItem) {
            activeItem.dataset.value = firstValid;
            activeItem.querySelector('span') && (activeItem.querySelector('span').textContent = firstValid);
        }

        // Fire change so variant-selects picks it up.
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
    }

    function handleVariantSelectChange(event) {
        const variantSelectsEl = event.currentTarget;
        const selects = variantSelectsEl.querySelectorAll('select[data-uc-select-value]');
        if (selects.length < 2) return; // Nothing to sync

        const variantData = getVariantData(variantSelectsEl);
        if (!variantData.length) return;

        // Determine which select just changed and only act on primary (option1) changes.
        const changedSelect = event.target;
        if (changedSelect !== selects[0]) return; // only care about the first option

        const primaryOptionKey = 'option1';
        const secondaryOptionKey = 'option2';

        const primaryValue = selects[0].value;
        const currentSecondaryValue = selects[1].value;

        const validValues = getValidSecondaryValues(variantData, primaryValue, primaryOptionKey, secondaryOptionKey);
        if (!validValues.length) return;

        // Find the secondary select-disclosure-without-form wrapper.
        const disclosureEls = variantSelectsEl.querySelectorAll('select-disclosure-without-form');
        if (disclosureEls.length < 2) return;
        const secondaryDisclosure = disclosureEls[1];

        // Show/hide items in the dropdown list.
        syncDisclosureList(secondaryDisclosure, validValues);

        // Auto-select first valid value if current is invalid.
        autoSelectFirstValid(secondaryDisclosure, validValues, currentSecondaryValue);
    }

    function syncOnLoad(variantSelectsEl) {
        const variantData = getVariantData(variantSelectsEl);
        if (!variantData.length) return;

        const selects = variantSelectsEl.querySelectorAll('select[data-uc-select-value]');
        if (selects.length < 2) return;

        const disclosureEls = variantSelectsEl.querySelectorAll('select-disclosure-without-form');
        if (disclosureEls.length < 2) return;

        const primaryValue = selects[0].value;
        const currentSecondaryValue = selects[1].value;
        const validValues = getValidSecondaryValues(variantData, primaryValue, 'option1', 'option2');
        if (!validValues.length) return;

        syncDisclosureList(disclosureEls[1], validValues);
        autoSelectFirstValid(disclosureEls[1], validValues, currentSecondaryValue);
    }

    function attachToVariantSelects(variantSelectsEl) {
        variantSelectsEl.addEventListener('change', handleVariantSelectChange);
    }

    // Attach to all variant-selects elements already in the DOM and run initial sync.
    document.querySelectorAll('variant-selects').forEach(el => {
        attachToVariantSelects(el);
        syncOnLoad(el);
    });

    // Also handle dynamically loaded sections (Quick Add modal, etc.).
    document.addEventListener('shopify:section:load', () => {
        document.querySelectorAll('variant-selects').forEach(el => {
            attachToVariantSelects(el);
            syncOnLoad(el);
        });
    });

    // Quick-add modal injects content dynamically – observe for new variant-selects.
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (!(node instanceof HTMLElement)) return;
                const els = node.tagName === 'VARIANT-SELECTS'
                    ? [node]
                    : Array.from(node.querySelectorAll ? node.querySelectorAll('variant-selects') : []);
                els.forEach(el => { attachToVariantSelects(el); syncOnLoad(el); });
            });
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });
}());
